import { CircleFlag } from "react-circle-flags";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

import type { RouterOutputs } from "@/lib/trpc";

import { useTranslationUtils } from "@/hooks/use-translation-utils";
import { routes } from "@/routes";

export function TournamentClub({ club }: { club: RouterOutputs["club"]["getClub"] }) {
  const { getCountryName } = useTranslationUtils();
  const { t } = useTranslation(["tournaments"]);
  const navigate = useNavigate();

  return (
    <div className="flex flex-col rounded-xl border">
      <div className="flex items-center justify-center rounded-t-xl bg-neutral-50 py-1.5">
        <span className="text-sm font-medium text-neutral-500">
          {t("tournaments:organize-by")}
        </span>
      </div>

      <button type="button" onClick={() => navigate(routes.getClubPath(club.clubRepresentativeId), { state: { fromPath: routes.tournaments } })} className="flex items-center gap-2 p-1.5">
        <img
          src={club.imgUrl}
          alt={`Profil de ${club.clubName}`}
          className="pointer-events-none size-16 shrink-0 select-none rounded-xl bg-white object-cover"
        />

        <div className="flex w-full min-w-0 flex-col items-start gap-1">
          <h1 className="truncate text-lg font-semibold">{club.clubName.toUpperCase()}</h1>

          <span className="truncate text-sm font-medium text-neutral-500 lg:block">
            {`${club.clubCity}, ${getCountryName(club.clubCountryCode)}`}
          </span>
        </div>

        <div className="flex shrink-0 items-center gap-1.5 rounded-full bg-neutral-100 p-0.5">
          <CircleFlag countryCode={club.clubCountryCode.toLowerCase()} className="size-4 rounded-full" />
          <span className="block pr-3 text-sm font-medium">
            {club.clubCountryCode.toUpperCase()}
          </span>
        </div>
      </button>
    </div>
  );
}
